import autobahn from 'autobahn';

export default class WAMP {

	static getInstance() {
		if (!WAMP._instance) {
			WAMP._instance = new WAMP();
		}
		return WAMP._instance;
	}

	constructor() {
		let settings = JSON.parse(datapas.wampSettings);

		this.subscriptions = new Map();
		this.connectedCallbacks = [];
		this.closedCallbacks = [];
		this.closed = false;
		this.connection = new autobahn.Connection({
			url: settings.url,
			realm: settings.realm,
			authmethods: ['jwt'],
			onchallenge: () => {
				return settings.token;
			}
		});

		this.connection.onopen = (session, details) => {
			console.log('WAMP: connected');
			this.closed = false;
			this.subscribeSubscriptions();
			this.connectedCallbacks.forEach((callback) => {
				callback();
			})
		};

		this.connection.onclose = (reason, details) => {
			console.log('WAMP: ' + reason, details);
			this.closed = true;
			this.subscriptions.forEach((subscription, topic) => {
				this.subscriptions.get(topic).subscribed = false;
			});
			this.closedCallbacks.forEach((callback) => {
				callback();
			});
		};
	}

	subscribeSubscriptions() {
		this.subscriptions.forEach((subscription, topic) => {
			if (!subscription.subscribed) {
				subscription.subscribed = true;
				this.connection.session.subscribe(topic, (args, kwargs, details) => {
					this.getTopicSubscriptions(topic).callbacks.forEach((callback) => {
						callback(args, kwargs, details);
					});
				}, {'disclose_publisher': true}).then((handle) => {
					subscription.handle = handle;
				}, (error) => {
					subscription.subscribed = false;
				});
			}
		});
	}

	getTopicSubscriptions(topic) {
		if (!this.subscriptions.has(topic)) {
			this.subscriptions.set(topic, {callbacks: [], subscribed: false, handle: null});
		}

		return this.subscriptions.get(topic);
	}

	callbackFn(args, kwargs, details) {
		this.getTopicSubscriptions(details.topic).callbacks.forEach((callback) => {
			callback(args, kwargs, details);
		});
	}

	openConnection() {
		try {
			this.connection.open();
		} catch (e) {
			// connection already open (or opening)
		}
	}

	subscribe(topic, callback) {
		this.openConnection();

		this.getTopicSubscriptions(topic).callbacks.push(callback);

		if (this.connection.isOpen) {
			this.subscribeSubscriptions();
		}
	}

	unsubscribe(topic) {
		let topicSubscriptions = this.getTopicSubscriptions(topic);

		if (topicSubscriptions.handle) {
			this.connection.session.unsubscribe(topicSubscriptions.handle);
		}

		topicSubscriptions.callbacks = [];
		topicSubscriptions.subscribed = false;
		topicSubscriptions.handle = null;
	}

	publish(topic, args, kwargs) {
		this.openConnection();

		this.connection.session.publish(topic, args, kwargs);
	}

	connected(callback) {
		this.connectedCallbacks.push(callback);
		if (this.connection.isConnected) {
			callback();
		}
	}

	onclose(callback) {
		this.closedCallbacks.push(callback);
		if (this.closed) {
			callback();
		}
	}
}
